/**
 * Uppercase the first character of a string.
 * @param {string} str - The input string.
 * @returns {string} - The string with the first character uppercased.
 */
export function capitalizeFirstChar(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}
